import { fmt } from 'IntlWrapper/IntlWrapper';
import aclMatrix from 'common/aclMatrix';
import { ACL_MATRIX } from 'common/permissions';
import { isUserAuthorized } from 'utils/helpers';

export const LOST_ORDERS_QUICK_FILTERS = [
  {
    label: fmt({ id: 'ops_control.lost_orders.filters.pending_on_hub' }),
    value: 0,
    isUserAuthorized: isUserAuthorized(aclMatrix.HUBS, [
      ACL_MATRIX.HUBS_ALLOWED_TO_GET_OPS_ROOM_LOST_DATA_PENDING_ON_HUB
    ])
  },
  {
    label: fmt({ id: 'ops_control.lost_orders.filters.pending_on_fleet' }),
    value: 1,
    isUserAuthorized: isUserAuthorized(aclMatrix.HUBS, [
      ACL_MATRIX.HUBS_ALLOWED_TO_GET_OPS_ROOM_LOST_DATA_PENDING_ON_FLEET
    ])
  },
  {
    label: fmt({ id: 'ops_control.lost_orders.filters.pending_on_audit' }),
    value: 2,
    isUserAuthorized: isUserAuthorized(aclMatrix.HUBS, [
      ACL_MATRIX.HUBS_ALLOWED_TO_GET_OPS_ROOM_LOST_DATA_PENDING_ON_AUDIT
    ])
  },
  {
    label: fmt({ id: 'ops_control.lost_orders.filters.pending_on_unknown' }),
    value: 3,
    isUserAuthorized: isUserAuthorized(aclMatrix.HUBS, [
      ACL_MATRIX.HUBS_ALLOWED_TO_GET_OPS_ROOM_LOST_DATA_PENDING_ON_UNKNOWN
    ])
  },
  {
    label: fmt({ id: 'ops_control.lost_orders.filters.confirmed_lost' }),
    value: 4
  }
];

export const LOST_ORDER_SLA_MAX_LEVEL = 2;

export const FOUND_IT = 'FOUND_IT';

export const STAR_LIABLE = 'STAR_LIABLE';

export const FOUND_PROOF_IMAGES = 'proofOfFoundDeliveryImages';

export const LIABLE_PROOF_IMAGES = 'proofOfLiabilityImages';

export const COMMENT_SOURCE = {
  STAR: 'Star',
  HUB: 'Hub'
};

export const LOST_ORDERS_DATE_FORMAT = 'YYYY-MM-DD';

export const LOST_ORDERS_DATE_RANGE_OPTIONS = {
  START_DATE: 0,
  END_DATE: 1
};
